// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__Rh6eg","noInteraction":"EventWrapper_noInteraction__1FEAf","pointerPassthrough":"EventWrapper_pointerPassthrough__2C2xj"};